"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPermalink = exports.reversePlaceholders = exports.replacePlaceholders = exports.isUUID = exports.isEmail = exports.parseAddressString = exports.isAddressString = void 0;
var address_1 = require("./address");
Object.defineProperty(exports, "isAddressString", { enumerable: true, get: function () { return address_1.isAddressString; } });
Object.defineProperty(exports, "parseAddressString", { enumerable: true, get: function () { return address_1.parseAddressString; } });
var email_1 = require("./email");
Object.defineProperty(exports, "isEmail", { enumerable: true, get: function () { return email_1.isEmail; } });
var uuid_1 = require("./uuid");
Object.defineProperty(exports, "isUUID", { enumerable: true, get: function () { return uuid_1.isUUID; } });
var replacePlaceholders_1 = require("./replacePlaceholders");
Object.defineProperty(exports, "replacePlaceholders", { enumerable: true, get: function () { return replacePlaceholders_1.replacePlaceholders; } });
var reversePlaceholders_1 = require("./reversePlaceholders");
Object.defineProperty(exports, "reversePlaceholders", { enumerable: true, get: function () { return reversePlaceholders_1.reversePlaceholders; } });
var permalink_1 = require("./permalink");
Object.defineProperty(exports, "getPermalink", { enumerable: true, get: function () { return permalink_1.getPermalink; } });
